import { SearchFields } from '@/types/api';
import { useGetNewTalkFlowList } from '@/hooks/apiHooks';
import Loading from '@/components/MobileApproval/Body/Loading';
import { INIT_WEB_DOCUMENT_FILTER_STATE } from '@/recoil/init_data';
import DocumentContents from '@/components/MobileApproval/MobileDocument/DocumentContents';
import useDocuments from '@/components/MobileApproval/hooks/useDocuments';
import React from 'react';

type P = {
  keyword?: string;
};

const SearchDocument = ({ keyword }: P) => {
  const params = {
    ...INIT_WEB_DOCUMENT_FILTER_STATE,
    documentTypes: '',
    createdBy: [],
    internalParticipants: undefined,
    keyword: keyword ?? '',
    searchFields: 'subject,content' as SearchFields,
  };

  const {
    isLoading,
    resultData,
    handleBookmark,
    isReachingEnd,
    readMoreData,
    data,
  } = useDocuments({
    params,
  });

  const { data: totalCount } = useGetNewTalkFlowList({
    ...params,
  });

  return (
    <div style={{ marginTop: '20px', padding: '0px 8px' }}>
      <div style={{ fontSize: '14px' }}>
        총{' '}
        <span style={{ color: 'var(--dk-accent, #06C)', fontWeight: '700' }}>
          {totalCount?.meta.totalCount || 0}
        </span>
        건
      </div>
      <DocumentContents data={resultData} handleBookmark={handleBookmark} />
      {data && !isLoading && !isReachingEnd && (
        <Loading readMoreData={readMoreData} />
      )}
    </div>
  );
};

export default SearchDocument;
